import { __awaiter, __generator } from "tslib";
import GoogleAnalyticsVersions from "../../googleAnalytics/AnalyticsVersions";
import { resolveAnalyticsVersionByTakingIntoAccountThePreferredVersion, resolveAnalyticsVersionWhenReady, } from "../../googleAnalytics/Utils";
import AdapterGtag from "./googleAnalytics/GTag";
import AdapterGTM from "./googleAnalytics/GTM";
import AdapterUniversal from "./googleAnalytics/Universal";
/**
 * GoogleAnalytics
 * Knows how to resolve the current Google Analytics implementation of the
 * website and selects the related adapter to process the tracking
 */
var GoogleAnalytics = /** @class */ (function () {
    function GoogleAnalytics(config) {
        var _this = this;
        this.getAdapter = function () {
            if (!_this.adapterReady) {
                _this.adapterReady = new Promise(function (resolver, rejector) {
                    _this.adapterResolver = resolver;
                    _this.adapterRejector = rejector;
                });
                resolveAnalyticsVersionWhenReady()
                    .then(function (version) {
                    var finalVersion = resolveAnalyticsVersionByTakingIntoAccountThePreferredVersion(_this.configuredGaVersion, version);
                    _this.adapter = _this.adapterFactory(finalVersion);
                    _this.adapterResolver(_this.adapter);
                })
                    .catch(_this.adapterRejector);
            }
            return _this.adapterReady;
        };
        this.gtagConfig = config.gtagConfig;
        this.universalConfig = config.universalConfig;
        this.gtmConfig = config.gtmConfig;
        this.configuredGaVersion = config.configuredGaVersion;
    }
    GoogleAnalytics.prototype.record = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var adapter;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAdapter()];
                    case 1:
                        adapter = _a.sent();
                        if (adapter) {
                            return [2 /*return*/, this.adapter.record(request)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    GoogleAnalytics.prototype.getName = function () {
        return __awaiter(this, void 0, void 0, function () {
            var adapter;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAdapter()];
                    case 1:
                        adapter = _a.sent();
                        return [2 /*return*/, adapter ? adapter.getName() : "GoogleAnalyticsResolver::unresolvable"];
                }
            });
        });
    };
    GoogleAnalytics.prototype.adapterFactory = function (version) {
        switch (version) {
            case GoogleAnalyticsVersions.Gtag:
            case GoogleAnalyticsVersions.GtagUniversal:
                return new AdapterGtag(this.gtagConfig);
            case GoogleAnalyticsVersions.GoogleTagManager:
                return new AdapterGTM(this.gtmConfig);
            case GoogleAnalyticsVersions.Universal:
                return new AdapterUniversal(this.universalConfig);
            case GoogleAnalyticsVersions.Classic:
                if (process.env.APP_MODE !== "optimized") {
                    throw new Error("Adapter for GA " + GoogleAnalyticsVersions.Classic + " not implemented");
                }
            default:
                return null;
        }
    };
    return GoogleAnalytics;
}());
export default GoogleAnalytics;
//# sourceMappingURL=GoogleAnalytics.js.map